export namespace GlobalConstants {
  export const USER = 'Utilisateur';
  export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
  export const DREDGING_EQUIPMENT_TYPE = 'dredging_equipment';
  export const TUNNELING_EQUIPMENT_TYPE = 'tunneling_equipment';
  export const GENERIC_RESOURCE_OWNER = 'USIRF';
  export const GENERIC_RESOURCE_AUTHOR = 'SEVE-TP';
  export const GENERIC_RESOURCE_ACU_AUTHOR = 'ACU_SEVE-TP';
}
